import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transport',
  templateUrl: './transport.component.html',
  styleUrls: ['./transport.component.scss']
})
export class TransportComponent implements OnInit {
  imgUrl=[
    '/assets/img/transport/1.jpeg'
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
